import React, { createContext, type Dispatch, useReducer } from 'react';

import { type Country, type OpUpdate } from '../../restapi/types';


// Redux like Storage for useReducer
interface OpUpdatesState {
	copyToContent: (opUpdate: OpUpdate) => void;
	countries: Country[];
}

export const opUpdatesInitialValue: OpUpdatesState = {
	countries: [],
	copyToContent: () => {},
}

export const SET_COUNTRIES = 'SET_COUNTRIES';

export function setOpUpdatesCountries(countries: Country[]) {
	return {
		type: SET_COUNTRIES as typeof SET_COUNTRIES,
		payload: {countries: countries},
	}
}

export const SET_COPY_TO_CONTENT = 'SET_COPY_TO_CONTENT';

export function setCopyToContent(copyToContent: (opUpdate: OpUpdate) => void) {
	return {
		type: SET_COPY_TO_CONTENT as typeof SET_COPY_TO_CONTENT,
		payload: {copyToContent: copyToContent},
	}
}

type OpUpdatesAction =
	ReturnType<typeof setOpUpdatesCountries>
	| ReturnType<typeof setCopyToContent>;

function opUpdatesReducer(state: OpUpdatesState, action: OpUpdatesAction) {
	switch (action.type) {
		case SET_COUNTRIES:
			return {...state, countries: action.payload.countries};
		case SET_COPY_TO_CONTENT:
			return {...state, copyToContent: action.payload.copyToContent};
	}
}


// React Context ready to host an instance of opUpdatesReducer
interface OpUpdatesContext {
	state: OpUpdatesState;
	dispatch: Dispatch<OpUpdatesAction>;
}
const opUpdatesInitialContext = {
	state: opUpdatesInitialValue,
	dispatch: () => {},
}
export const opUpdatesContext = createContext<OpUpdatesContext>(opUpdatesInitialContext);


// Provider for opUpdatesContext
export function OperationalUpdatesStateProvider({children}: React.PropsWithChildren<{}>) {
	const [state, dispatch] = useReducer(opUpdatesReducer, opUpdatesInitialValue);
	const {Provider} = opUpdatesContext;
	return <Provider value={{state, dispatch}}>{children}</Provider>;
}
